"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default(theme) {
  return {
    root: {
      outline: 'none'
    },
    Label: {
      width: 153,
      marginRight: 17,
      padding: '0 0 5px 0'
    },
    error: (0, _extends2.default)({}, theme.typography.smallText, {
      position: 'absolute',
      lineHeight: '20px',
      bottom: -21,
      color: theme.colors.red
    }),
    bulkEdit: {
      display: 'flex',
      justifyContent: 'flex-start',
      padding: '0 0 5px 0',
      color: theme.colors.disabledGrey
    },
    bulkCancel: {
      position: 'absolute',
      lineHeight: '20px',
      bottom: -30
    },
    formControl: {
      position: 'relative',
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      width: 290,
      lineHeight: 0
    },
    checkbox: {
      width: '100%',
      lineHeight: '20px',
      flexGrow: 1,
      outline: 'none',
      border: 'none'
    },
    errored: {
      paddingBottom: '30px !important',
      '& $formControl': {
        '&::before': {
          borderBottom: "1px solid ".concat(theme.colors.red, " !important")
        },
        '&::after': {
          borderBottom: "1px solid ".concat(theme.colors.red, " !important")
        }
      }
    },
    vertical: {
      display: 'block',
      padding: '15px 0 10px 0',
      marginLeft: '0 !important',
      '& $formControl': {
        marginTop: 10
      },
      '& $Label': {
        width: '100%'
      }
    },
    horizontal: {
      display: 'flex',
      alignItems: 'center',
      padding: '15px 0 10px 0',
      '& $error': {}
    },
    isFullWidth: {
      '& $formControl': {
        width: '100%',
        flex: 1
      },
      '&$vertical $Label': {
        width: '100%'
      }
    },
    withBulk: {
      paddingBottom: '39px !important'
    },
    withErrorBulk: {
      paddingBottom: '54px !important',
      '& $bulkCancel': {
        bottom: -49
      }
    }
  };
};

exports.default = _default;